export default "__VITE_ASSET__CravcjNG__"